<template>
  <div class="set">
    <van-nav-bar :title="$t('m.rlb_span4')" left-text="" @click-left="onClickLeft" left-arrow>
    </van-nav-bar>

    <!-- <form> -->
    <div class="rlbaddbox">
      <div class="rlbaddtitle">{{$t('m.rlb_span8')}}</div>
      <div class="rlbinpbox">
        <div class="rlbrmb">￥</div>
        <input
          type="number"
          :placeholder="$t('m.rlb_span10')"
          v-model="account"
          autocomplete="off"
        />
      </div>
      <!-- <div class="rlbaddtitle" style="padding-top:15px;">可转出金额{{ribao_account}}元</div> -->
    </div>
    <div class="rlbbtnbox">
      <button class="rlbbtn" style="background-color: var(--bg-color)" @click="ribaoOut">{{$t('m.rlb_span12')}}</button>
    </div>
    <!-- </form> -->
  </div>
</template>

<script>
import request from "@utils/request";
import "@/assets/css/rilibao/rlbadd.css";
// import {ribaoOutPost,AccountPost} from "@/components/model";
export default {
  //   name: "",
  data() {
    return {
      account: "",
      ribao_account: ""
    };
  },
  created() {
    // this.Account();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    // async Account() {
    // 	let res = await AccountPost();
    // 	if (res) {
    // 		this.ribao_account = res.data.ribao_account;
    // 	}
    // },
    async ribaoOut() {
      if (this.account == "") {
        this.$dialog.message("金额不能为空");
        return;
      }
      if (this.account <= 0) {
        this.$dialog.message("金额的值必须不小于1");
        return;
      }
      request
        .post(
          "/user/ribao/out",
          { money: this.account },
          { login: true }
        )
        .then(res => {
          this.$router.push({
            path: "/rilibaoindex"
          });
          this.$dialog.success("转出成功");
          // console.log("转出");
          console.log(res);
        })
        .catch(err => {
          this.$dialog.error(err.response.data.msg);
        });
    }
  },
  components: {}
};
</script>
<style scoped lang="less">
.rlbbtn:active {
  opacity: 0.3 !important;
}
/deep/ .van-nav-bar .van-icon {
  color: #333;
}
</style>
